'use stric'

const countOnPage = [
  {
    title: '10',
    value: 10,
  },
  {
    title: '20',
    value: 20,
  },
  {
    title: 'Все',
    value: -1,
  },
]

const getCountOnPageTitle = (value) => {
  return countOnPage.filter((item) => item.value === value)[0].title
}

export {
  countOnPage,
  getCountOnPageTitle
}